<div class="navbar-wrapper">
  <nav class="navbar navbar-static-top">
    <div class="d-lg-flex flex-wrap flex-row container-fluid pb-1 pe-4">
      <div class="col-lg-2 ps-0 ms-0">
        <img src="/assets/images/TasGovHorWhite100.png" alt="logo"  />
      </div>
      <div class="col-lg-10 pt-2 d-flex justify-content-lg-end justify-content-sm-start">
        <a (click)="healthInformation()"
          class="healthHeader header-Link me-5 text-center headerMainLink">health.tas.gov.au</a>
        <a (click)="help()" class="helpHeader header-Link headerSubLink">Help</a> 
        <span class="helpHeader header-Link headerSubLink">/</span>
        <a (click)="contact()" class="helpHeader header-Link headerSubLink">Contact Us</a> 
      </div>
    </div>
  </nav>
</div>

<div class="container-fluid ms-0 ps-0 me-0 pe-0">
  <section>
      <div class="text-container" style="min-height: 330px;">
        <div class="d-lg-flex flex-wrap flex-row pt-3">
          <div class="col-lg-12 safescript-gutters">
            <img src="/assets/images/TasScript GD Flat100.png" alt="logo" />
            <p class="bannerText m-0 pt-3 pb-0">TasScript is a clinical decision support tool which provides prescribers and pharmacists access to real-time information regarding a patient’s monitored medicines history so they can make more informed decisions regarding the supply of these medicines.</p>
          </div>
        </div>
      </div>
  </section>
  
  <div class="register-container overlay">
    <div class="d-lg-flex flex-wrap flex-row">   

      <div class="col-lg-4 safescript-gutters">
        <div class="shadebox justify-content-start">
          <div class="register-container-header">
            <p class="boxHeading m-0 p-0">Health Practitioner</p>
            <p class="boxHeading m-0 p-0">Registration</p>
          </div>
          <div class="d-lg-flex d-md-flex register-container-info">
            <p class="boxText wrapText mt-1">
              <span>Eligible AHPRA-registered prescribers and pharmacists can sign-up for
                TasScript access here.</span>
            </p>
          </div>
  
          <button class="btn btn-lg btn-primary safescript-button boxButton" type="button"
            (click)="registrationLogin()">Register</button>
  
        </div>
      </div>

      <div class="col-lg-4 safescript-gutters">
        <div class="shadebox justify-content-start">
          <div class="register-container-header">
            <p class="boxHeading m-0 p-0">Health Practitioner </p>
            <p class="boxHeading m-0 p-0">Training</p>
          </div>
          <div class="d-lg-flex d-md-flex register-container-info">
            <p class="boxText mt-1">
              <span class="wrapText"> Health practitioners can access information regarding the use of TasScript here.</span>
            </p>
          </div>
          <button class="btn btn-lg btn-primary safescript-button boxButton" type="button"
            (click)="prescriberTraining()">Training</button>
        </div>
      </div>
  
      
      <div class="col-lg-4 safescript-gutters">
        <div class="shadebox justify-content-start">
          <div class="register-container-header">
            <p class="boxHeading m-0 p-0">Health Practitioner</p>
            <p class="boxHeading m-0 p-0">Login</p> 
          </div>
          <div class="d-lg-flex d-md-flex register-container-info">
            <p class="boxText wrapText mt-1">
              <span>Already registered? </span>
              <br />
              <span>
                Log in to access TasScript here.
              </span>
            </p>
          </div>
  
          <button class="btn btn-lg btn-primary safescript-button boxButton" type="button"
            (click)="hpLogin()">Login</button>
  
        </div>
      </div>

    </div>

    <div class="pt-4">
      <div class="d-lg-flex flex-wrap">
        <div class="col-lg-12 p-2">
          <div class="d-lg-flex justify-content-center">
            <span class="patientHeading"> I am a patient </span>
          </div>
          <div class="d-lg-flex justify-content-center">
            <p class="patientText">
              <span class="wrapText">For information for patients relating to TasScript, click <a class="patient-Link" target="blank" rel="noopener noreferrer" (click)="patientInfo()">here.</a>
              </span>
              <br>
            </p>
          </div>
        </div>
      </div>
    </div>

  </div>
  



</div>
  
  <div class="support-container container-fluid pt-3 ps-3 pe-3">
    <div class="d-lg-flex flex-wrap">
      <div class="col-lg-4 p-2 justify-content-start">
        <div>
          <i class="fa fa-user-headset faAct">
          </i>
        </div>
        <div class="d-lg-flex pt-1">
          <p class="supportLinksHeading m-0 p-0">
            Support
          </p>
        </div>
        <div>
          <p class="m-0 p-0 supportText">Technical support:</p>
          <a class="qscript-Link emailText wrapText" [href]="supportEmail">itsupport.tasscript&#64;health.tas.gov.au</a>
        </div>
        <div>
          <p class="m-0 p-0 supportText">General enquiries:</p>
          <a class="qscript-Link emailText wrapText" (click)="generalEnquiries()">tasscript&#64;health.tas.gov.au</a>
        </div>
      </div>
      <div class="col-lg-4 p-2 justify-content-start">
        <div>
          <i class="fa fa-desktop faAct">
          </i>
        </div>
        <div class="d-lg-flex pt-1">
          <p class="supportLinksHeading m-0 p-0"> TasScript Information</p>
        </div>
        <div>
          <span class="m-0 p-0 supportText">For more information on TasScript,<br />
            click <a class="qscript-Link supportText" target="blank" rel="noopener noreferrer" href="https://www.health.tas.gov.au/health-topics/medicines-and-poisons-regulation/medicines-and-poisons-regulation-information-health-professionals/real-time-prescription-monitoring">here</a></span>
        </div>
      </div>
      <div class="col-lg-4 p-2 justify-content-start">
        <div>
          <i class="fa fa-wrench faAct">
          </i>
        </div>
        <div class="d-lg-flex pt-1">
          <p class="supportLinksHeading m-0 p-0">
            Planned maintenance and updates
          </p>
        </div>
        <div class="d-lg-flex">
          <app-outtage-message *ngIf="config" [outageText]="config.maintenance"></app-outtage-message>
        </div>
      </div>
    </div>
  </div>


<footer class="footer-box">
    <div class="d-lg-flex flex-row mb-0">
      <div class="col-lg-12 row d-flex justify-content-lg-center pt-2">
        <div class="col-4"></div>
        <div class="col-lg-4 d-flex justify-content-around px-5 px-md-4">
          <div class="col-lg-4 d-sm-flex justify-content-center">
            <a target="blank" rel="noopener noreferrer" class="safescript-Link footerLink" href="{{this.config?.supportUrl}}">Support</a>
          </div>
          <div class="col-lg-4 d-sm-flex justify-content-center">
            <a target="blank" rel="noopener noreferrer" class="safescript-Link footerLink" href="{{this.config?.termsUrl}}">Terms of Access & Use</a>
          </div>
          <div class="col-lg-4 d-sm-flex justify-content-center">
            <a target="blank" rel="noopener noreferrer" class="safescript-Link footerLink" href="{{this.config?.privacyUrl}}">Privacy</a>
          </div>
        </div>
        <div class="col-4"></div>
      </div>
    </div>
    <div class="d-lg-flex flex-row mb-0">
      <div class="col-lg-12 d-flex justify-content-center pt-2">
           <img src="/assets/images/TasGovHorWhite100.png" style="height:60px;" class="img-fluid" alt="logo" />
      </div>
    </div>
</footer>